<template>
<!--我的-->
<div id="personinfo">
  <header>
    <div class="profile" v-if="this.$store.state.uid">
      <a class="avatar" :style="{backgroundImage: 'url(' + this.$store.state.portrait + ')'}"></a>
      <div>
        <a><h3>{{this.$store.state.name}}</h3></a>
        <p>同步数据，学习更安心</p>
      </div>
      <a @click="signIn" class="sign" v-show="signShow === 1">签到打卡</a>
    </div>
    <div class="profile" v-else>
      <router-link :to="{name: 'PwdLogin', query: {backto: 'PersonInfo'}}" class="avatar"></router-link>
      <div>
        <router-link :to="{name: 'PwdLogin', query: {backto: 'PersonInfo'}}"><h3>点击登录</h3></router-link>
        <p>登录同步数据，学习更安心</p>
      </div>
      <router-link to="PwdLogin" class="sign" v-show="signShow === 1">签到打卡</router-link>
    </div>
    <div class="ad-vip">
      <img :src="isVIP ? require('../../assets/icon/personinfo_icon_crown1.png') : require('../../assets/icon/personinfo_icon_crown0.png')" alt="">
      <!--<img :src="vipImageUrl" alt="">-->
      <p>
        全站海量视频无限学习3天 为学习加速！
      </p>
      <a href="javascript:" class="buy" v-if="isVIP">
        <b>VIP会员</b><br>
        已开通会员
      </a>
      <router-link to="BuyVip" class="buy" v-else>
        <b>VIP会员</b><br>
        去开通>
      </router-link>
    </div>
  </header>

  <nav>
    <!--
    <a href=""><i class="myclass"></i>我的课程</a>
    <a href=""><i class="collection"></i>我的收藏</a>
    <a href=""><i class="material"></i>我的资料</a>
    <a href=""><i class="mywrong"></i>错题库</a>
    <a href=""><i class="coupon"></i>优惠券</a>
    <a href=""><i class="myorder"></i>我的订单</a>
    <a href=""><i class=""></i>班主任</a>
    -->
    <a @click="gotoUrl(item.href)" v-for="(item, index) in JurisdictionData" :key="index"><i class="" :style="{backgroundImage: 'url('+item.img+')'}" :alt="item.img"></i>{{item.name}}</a>
  </nav>
  <hr>
  <!--功能-->
  <div class="func">
    <a :href="item.href" v-for="(item, index) in OperationData" :key="index">
      {{item.name}}
    </a>
  </div>
  <!--广告-->
  <div class="ad-banner">
    <a href=""><img src="../../assets/img/personinfo_ad_banner1.png" alt=""></a>
  </div>
  <!--邀请好友-->
  <div class="invite">
    <a href="">
      <div class="left">
        <h4>邀请好友下载APP</h4>
        <p>
          有机会得好礼
        </p>
      </div>
      <div class="right"></div>
    </a>
  </div>
  <!--底部占位-->
  <div id="fix-bottom-void"></div>
  <bottom-bar :index="3"></bottom-bar>
</div>
</template>

<script>
import BottomBar from '../share/fixed/BottomBar'
export default {
  name: 'PersonInfo',
  data () {
    return {
      signShow: 1,
      isVIP: 0,
      showVIP: 1,
      JurisdictionData: {},
      OperationData: {},
      signInData: {}
    }
  },
  components: {
    BottomBar
  },
  mounted () {
    this.validateLogin()
    this.getShowSing()
    // this.showIsVip()
    this.getIsVip()
    this.getJurisdiction()
    this.getOperation()
  },
  methods: {
    getShowSing () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_is_signIn',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            console.log('显示签到')
            console.log(res)
            this.signShow = res.data.data.status
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin', query: {backto: 'PersonInfo'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 是否显示VIP
    showIsVip () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_is_vip',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.showVIP = res.data.data.status
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin', query: {backto: 'PersonInfo'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 判断是不是VIP
    getIsVip () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_opening_vip',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.isVIP = res.data.data.status
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin', query: {backto: 'PersonInfo'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getJurisdiction () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_is_jurisdiction',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.JurisdictionData = res.data.data
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin', query: {backto: 'PersonInfo'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getOperation () {
      let data = {}
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_is_operation',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.OperationData = res.data.data
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin', query: {backto: 'PersonInfo'}})
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin', query: {backto: 'PersonInfo'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    signIn () {
      let data = {}
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_signIn_page',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.signInData = res.data.data
            alert('签到成功！')
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    validateLogin () {
      if (!this.$store.state.uid) {
        // this.$router.push({name: 'PwdLogin', query: {backto: 'PersonInfo'}})
      }
    },
    validateToken () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/overdue_user_token',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log('验证登录：')
          console.log(res)
          if (res.data.errcode !== 200) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
          }
        })
        .catch(err => { console.log(err) })
    },
    gotoUrl (href) {
      if (this.$store.state.uid) {
        this.$router.push({path: href})
      } else {
        this.$router.push({name: 'PwdLogin', query: {backto: 'PersonInfo'}})
      }
    }
  }
}
</script>

<style scoped lang="stylus">
#personinfo
  header
    width: 7.5rem
    height: 4.06rem
    background: url(../../assets/img/personinfo_bg_header.png) no-repeat center
    -webkit-background-size: 100%
    background-size: 100%
    overflow: visibility
    padding-top: 1.2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .profile
      position: relative
      display: flex
      justify-content: left
      align-items: center
      padding: 0 0 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.avatar
        position: relative
        display: block
        width: 1.36rem
        height: 1.36rem
        border: .02rem solid #fff
        background: url(../../assets/img/personinfo_img_avatar.png) no-repeat center #fff
        -webkit-background-size: 1.36rem
        background-size: 1.36rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::after
          content: ""
          position: absolute
          bottom: 0
          right: .1rem
          display: inline-block
          width: .28rem
          height: .28rem
          background: url(../../assets/icon/personinfo_icon_edit.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
      a.sign
        position: absolute
        right: 0
        display: block
        width: 2.24rem
        height: .64rem
        line-height: .64rem
        background-color: #fff
        padding: 0 0 0 .76rem
        -webkit-border-radius: 2rem 0 0 2rem
        -moz-border-radius: 2rem 0 0 2rem
        border-radius: 2rem 0 0 2rem
        font-size: .32rem
        color: #FF7052
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &::before
          content: ""
          position: absolute
          top: .08rem
          left: .2rem
          display: inline-block
          width: .36rem
          height: .46rem
          background: url(../../assets/icon/personinfo_icon_sign.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
      & > div
        margin-left: .2rem
        h3
          font-size: .36rem
          color: #fff
        p
          font-size: .24rem
          color: #fff
          margin-top: .1rem
    .ad-vip
      display: flex
      justify-content: space-between
      align-items: center
      width: 7.1rem
      height: 1.64rem
      background-color: #fff
      margin: .56rem auto 0
      padding: .4rem
      -webkit-box-shadow: 0rem 0.08rem 0.12rem 0rem rgba(237,237,237,0.67)
      -moz-box-shadow: 0rem 0.08rem 0.12rem 0rem rgba(237,237,237,0.67)
      box-shadow: 0rem 0.08rem 0.12rem 0rem rgba(237,237,237,0.67)
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      img
        width: .8rem
        height: .6rem
      p
        width: 3.02rem
        height: .72rem
        font-size: .26rem
        color: #0C0C0C
      a.buy
        display: block
        width: 1.62rem
        height: .84rem
        line-height: .30rem
        background-color: #FF7052
        padding-top: .12rem
        font-size: .24rem
        color: #fff
        text-align: center
        -webkit-border-radius: .16rem
        -moz-border-radius: .16rem
        border-radius: .16rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        b
          font-size: .28rem
          font-weight: 500
  nav
    display: flex
    justify-content: flex-start
    align-items: center
    flex-wrap: wrap
    align-content: center
    padding: .8rem .15rem 0
    margin: 0 0 .4rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a
      display: block
      width: 1.2rem
      height: 1rem
      margin: .4rem .3rem 0
      font-size: .24rem
      color: #333
      text-align: center
      i
        display: block
        width: .53rem
        height: .53rem
        margin: 0 auto .14rem
        background: url(../../assets/icon/personinfo_icon_client.png) no-repeat center
        -webkit-background-size: .52rem
        background-size: .52rem
        &.myclass
          background-image: url(../../assets/icon/personinfo_icon_myclass.png)
          -webkit-background-size: .48rem .44rem
          background-size: .48rem .44rem
        &.collection
          background-image: url(../../assets/icon/personinfo_icon_collection.png)
        &.material
          background-image: url(../../assets/icon/personinfo_icon_material.png)
        &.mywrong
          background-image: url(../../assets/icon/personinfo_icon_mywrong.png)
          -webkit-background-size: .44rem .52rem
          background-size: .44rem .52rem
        &.coupon
          background-image: url(../../assets/icon/personinfo_icon_coupon.png)
          -webkit-background-size: .4rem .52rem
          background-size: .4rem .52rem
        &.myorder
          background-image: url(../../assets/icon/personinfo_icon_myorder.png)
          -webkit-background-size: .44rem .52rem
          background-size: .44rem .52rem
  hr
    width: 7.5rem
    height: .16rem
    border: none
    background-color: #F5F5F5
    clear: both
  .func
    padding: 0 .4rem .4rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a
      position: relative
      display: block
      width: 6.7rem
      height: 1.2rem
      line-height: 1.2rem
      border-bottom: .02rem solid #E7E8E9
      font-size: .3rem
      color: #020202
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      &::after
        content: ""
        position: absolute
        top: .5rem
        right: .2rem
        display: inline-block
        width: .15rem
        height: .15rem
        border-right: .02rem solid #A2A2A2
        border-bottom: .02rem solid #A2A2A2
        -webkit-transform: rotate(-45deg)
        -moz-transform: rotate(-45deg)
        -ms-transform: rotate(-45deg)
        -o-transform: rotate(-45deg)
        transform: rotate(-45deg)
  .ad-banner
    width: 7.5rem
    height: 1.2rem
    padding: 0 .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    img
      width: 7.1rem
      height: 1.2rem
  .invite
    width: 7.5rem
    height: 1.2rem
    padding: 0 .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a
      display: flex
      justify-content: space-between
      align-items: center
      width: 7.1rem
      height: 1.2rem
      background-color: #FDF7D6
      padding: .2rem .32rem
      margin: .32rem 0
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      .left
        background: url(../../assets/icon/personinfo_icon_invite.png) no-repeat left center
        -webkit-background-size: .6rem .64rem
        background-size: .6rem .64rem
        padding: 0 0 0 .96rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        h4
          font-size: .32rem
          color: #E89614
        p
          font-size: .22rem
          color: #D4B685
      .right
        position: relative
        width: .56rem
        height: .56rem
        background-color: #F2BF74
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::after
          content: ""
          position: absolute
          top: .2rem
          left: .14rem
          display: inline-block
          width: .15rem
          height: .15rem
          border-right: .04rem solid #fff
          border-bottom: .04rem solid #fff
          -webkit-transform: rotate(-45deg)
          -moz-transform: rotate(-45deg)
          -ms-transform: rotate(-45deg)
          -o-transform: rotate(-45deg)
          transform: rotate(-45deg)
  #fix-bottom-void
    height: 1rem
    clear: both
</style>



// WEBPACK FOOTER //
// src/components/personal/PersonInfo.vue